import { Form, Row, Col } from "react-bootstrap";
const CustomForm = ({
     formClassName,
  inputsConfig,
  
}) => {
  return (
   <Form className={formClassName} autoComplete="off">
  {inputsConfig.map((row, rowIndex) => (
    <Row className="profile-form-row" key={rowIndex}>
      {row.map((field, colIndex) => (
        <Col key={colIndex}>
          <Form.Group>
            <Form.Label>{field.label}</Form.Label>
            <input
                autoComplete="off"

              {...field} // spread all props (type, name, value, onChange, className...)
              style={{ height: "30px" }}
            />
          </Form.Group>
        </Col>
      ))}
    </Row>
  ))}
</Form>

  );
};

export default CustomForm;
